module.exports = __webpack_public_path__ + "img/weight-hanging-solid.5a28b71d.svg";